import api from './index.ts'
import config from '@/config'

export async function createChat() {
  return await api.post(`${config.chatbotUrl}/chats`, {})
}

export async function chatBot(data: { session_id: string; text: string }) {
  return await api.post(`${config.chatbotUrl}/chats/${data.session_id}/messages/user`, {
    message: data.text,
    mode: 'agent',
  })
}

export async function getChat(data: { session_id: string }) {
  return await api.get(`${config.chatbotUrl}/chats/${data.session_id}`, {})
}
